<template>
  <div class="paper-package">
    <headers :title="title" :goBackHandler="goBack">
    </headers>
    <div class="error-detail">
      <div class="error-title" v-if="type == 5"> 章节列表 </div>
      <div class="chapter" v-if="type == 5">
        <Empty v-if="active==0&&!chapterList.length"
               :empty_type="empty_type"></Empty>

        <van-collapse v-if="active==0"
                      v-model="activeNames"
                      :border="false"
                      class="collapse">
          <van-collapse-item :title="(index+1)+'、'+item.title" v-if="item.error_count > 0"
                             v-for="(item,index) in chapterList"
                             :key="index"
                             :border="false"
                             :name="index"
                             title-class="question_title"
                             value-class="question_count"
                             :value="'共'+item.error_count+'道'">
            <div v-for="(it,i) in item.children" :key="i" class="question_item" v-if="it.chapter_exam && it.chapter_exam.error_count > 0">
              <router-link :to="{ name: 'ErrorList', query: { id: it.chapter_exam.paper_id, type: 5, detach: detach } }">
                <span class="child_title"> {{it.title}}</span>
                <span class="child_question_num"> {{it.chapter_exam.error_count}}道</span>
              </router-link>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="daily" v-if="type == 6">
        <Empty v-if="active==0&&!chapterList.length"
               :empty_type="empty_type"></Empty>

        <List ref="daily"
              url="/api/app/myExam/error/checkin"
              method="get"
              :params="params"
              :on-getdata="onGetdata"
              class="lists">
              <ul class="news-content" slot="item">
                <router-link tag="li"
                             v-for="(item, index) in list"
                             :key="index"
                             :to="{ name: 'ErrorList', query: { id: item.paper_id, type: 6, detach: detach } }">
                  <div class="content">
                    <div class="daily-item">
                      <div class="daily-left">
                        <div class="checkdate">
                          第{{ item.every }}天
                        </div>
                        <div class="date">
                          {{ item.date }}
                        </div>
                      </div>
                      <div class="daily-right">
                        {{ item.error_count }}道 >
                      </div>
                    </div>
                  </div>
                </router-link>
              </ul>
            </List>
      </div>
    </div>
  </div>
</template>

<script>
import headers from "@/components/Header";
import List from "@/components/List";
import Empty from "@/components/Empty";
import preview from '@/components/que_answers/Preview';
export default {
  name: "ErrorQuesDetail",
  components: {
    headers,
    List,
    preview,
    Empty
  },
  data() {
    return {
      title: {
        name: "错题本"
      },
      type: this.$route.query.type || 5,
      active: 0,
      activeNames: [],
      empty_type: { name: '暂无数据' },
      chapterList: [],
      list: [],
      id: this.$route.query.id,
      params: {
        id: this.$route.query.id
      },
      detach: this.$route.query.detach == 1 ? 1 : 0,
    };
  },
  methods: {
    goBack () {
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    },
    requestList() {

    },

    /**
     * 获取章节列表
     */
    getExerciseChapter () {
      this.$http.get(`/api/app/myExam/error/exercise`, { id: this.id }).then((res) => {
        this.chapterList = res;
      });
    },

    onGetdata(data) {
      this.list = data;
    },
  },
  created () {
    this.exercise_id = this.$route.query.id;
    this.getExerciseChapter();
  },
};
</script>

<style lang='scss' scoped>
.theme-color {
  color: $theme_color !important;
}
.ques-color {
  color: $ques_color !important;
}

.error-detail{
  background: #FAFAFA;
  font-family: PingFangSC-Regular;
}
.error-detail .error-title {
  font-size: 30px;
  color: #333;
  padding-left: 30px;
  line-height: 80px;
  font-family: PingFangSC-Regular;
}
.chapter{
  background: #fff;
  font-family: PingFangSC-Regular;
  padding: 30px;
  .question_title{
    color: #333333;
  }
  .question_count{
    color: #333333;
  }
  .van-collapse-item{
    border: none;
  }
  .van-collapse-item .van-cell{
    color: #333333;
  }
  .van-cell__value span{
    color: #333333;
  }
  .question_item{
    line-height: 60px;
    color: #666666;
    font-size: 24px;
    padding-left: 25px;
    .child_question_num{
      float: right;
      margin-right: 25px;;
    }
    a span{
      color: #666666;
      cursor: pointer;
    }
  }
}
.news-content{
  .daily-item{
    height: 140px;
    display: flex;
    flex-wrap: wrap;
    flex: 1 0 auto;
    background: #ffffff;
    border-top: 1px solid #F6F6F6;
  }
  .daily-left{
    width: 60%;
    .checkdate{
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      line-height: 50px;
      padding-top: 25px;
      padding-left: 30px;
    }
    .date{
      color: #999999;
      font-size: 24px;
      line-height: 40px;
      padding-left: 30px;
    }
  }
  .daily-right{
    color: #666666;
    width: 38%;
    font-size: 24px;
    line-height: 140px;
    text-align: right;
  }
}
</style>
